// extracted by mini-css-extract-plugin
export default {"page":"O8SA0","pluginPage":"SdFVU","loading":"tqh9B","header":"PRsKn"};